import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { CheckItemModel } from '@shared/components/check-item/check-item-model.interface';

@Component({
  selector: 'app-checklist',
  templateUrl: './checklist.component.html',
  styleUrls: ['./checklist.component.scss'],
  standalone: false
})
export class ChecklistComponent implements OnInit {

  @Input() list: CheckItemModel[];
  @Input() numbered: boolean;
  @Input() highlightOnChecked: boolean;
  @Input() requiredHeading = 'You will need to opt-in to:';
  @Input() optionalHeading = 'You can also opt-in to:';

  requiredList: CheckItemModel[] = [];
  optionalList: CheckItemModel[] = [];
  listIsSplit = false;

  @Output() changed = new EventEmitter<void>();

  ngOnInit() {
    for (const item of this.list) {
      if (item.required) {
        this.requiredList.push(item);
      } else {
        this.optionalList.push(item);
      }
    }

    if (this.requiredList.length > 0 && this.optionalList.length > 0) {
      this.listIsSplit = true;
    }
  }

  onChange() {
    this.changed.next();
  }

}
